import React from 'react';
import Portal from '@reach/portal';
import { Spinner, SpinnerSize } from '@bechtel/gds';
import { BackdropStyled, SuspenseLoaderStyled } from './styled';

export const SuspenseLoader = () => {
  return (
    <Portal>
      <BackdropStyled>
        <SuspenseLoaderStyled>
          <Spinner size={SpinnerSize.LARGE}></Spinner>
        </SuspenseLoaderStyled>
      </BackdropStyled>
    </Portal>
  );
};
